// services/externalActions.ts

import { useMutation, useQuery, useQueryClient } from "react-query";

import axios from "axios";
import { nuclearn_api_url } from "src/App";

// === GET ALL EXTERNAL ACTIONS ===
const getAllExternalActions = () => {
  return axios
    .get(`${nuclearn_api_url}/external-action/`)
    .then((res) => res.data);
};

export const useGetAllExternalActions = () => {
  return useQuery(["externalActions"], getAllExternalActions);
};

// === GET EXTERNAL ACTION BY ID ===
const getExternalAction = (id: number) => {
  return axios
    .get(`${nuclearn_api_url}/external-action/${id}`)
    .then((res) => res.data);
};

/** Fetch one external action (e.g. an approval prompt's durable status). */
export const useGetExternalAction = (
  id: number | undefined,
  options?: { enabled?: boolean },
) => {
  return useQuery(
    ["externalAction", id],
    () => getExternalAction(id as number),
    {
      enabled: (options?.enabled ?? true) && typeof id === "number" && id > 0,
      staleTime: 30_000,
    },
  );
};

// === DELETE EXTERNAL ACTION ===
const deleteExternalAction = (id: number) => {
  return axios
    .delete(`${nuclearn_api_url}/external-action/${id}`)
    .then((res) => res.data);
};

export const useDeleteExternalAction = () => {
  const queryClient = useQueryClient();
  return useMutation((id: number) => deleteExternalAction(id), {
    onSuccess: () => {
      queryClient.invalidateQueries(["externalActions"]);
    },
  });
};

// === RUN EXTERNAL ACTION ===
const runExternalAction = (id: number) => {
  return axios
    .post(`${nuclearn_api_url}/external-action/${id}/run`)
    .then((res) => res.data);
};

export const useRunExternalAction = () => {
  const queryClient = useQueryClient();
  return useMutation((id: number) => runExternalAction(id), {
    onSuccess: () => {
      queryClient.invalidateQueries(["externalActions"]);
    },
  });
};

// === REJECT EXTERNAL ACTION ===
const rejectExternalAction = (id: number) => {
  return axios
    .post(`${nuclearn_api_url}/external-action/${id}/reject`)
    .then((res) => res.data);
};

export const useRejectExternalAction = () => {
  const queryClient = useQueryClient();
  return useMutation((id: number) => rejectExternalAction(id), {
    onSuccess: () => {
      queryClient.invalidateQueries(["externalActions"]);
    },
  });
};
